export default {
  getVideoPath (data) {
    let result = this.traversalToPath(data)
    if (result instanceof Array) {
      if(result[0].hasOwnProperty('videoUrl')){
        return result[0].videoUrl
      }else{
        return ''
      }
    } else {
      return result
    }
  },
  traversalToPath (data) {
    if(data){
      if (data.hasOwnProperty('PartGroup') && data.PartGroup.length) {
        return data.PartGroup
      }
      return data.videoUrl
    }else{
      return ''
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./utils/Tool.js
// module id = null
// module chunks = 